/*
 * shopPicker Actions
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 05-May-2025
 */

import { createAction, createRequestTypes, MakeRequest } from './index'

export const actionTypes = {
  DO_SET_SHOP_SELECTION: '@@shopPicker/set_shop_selection',
  CLEAR_SHOP_SELECTION: '@@shopPicker/clear_shop_selection',
  CLEAR_COSTS_SHOP_SELECTION: '@@shopPicker/clear_costs_shop_selection',
  DO_GET_SHOP_LIST: '@@shopPicker/get_shop_list',
  DO_GET_COSTS_SHOP_LIST: '@@shopPicker/get_costs_shop_list',
  DO_SET_COSTS_SHOP_SELECTION: '@@shopPicker/set_costs_shop_selection',
  DO_SET_SHOP_SEARCH_TERM: '@@shopPicker/set_shop_search_term',
  DO_CLEAR_SHOP_SEARCH_TERM: '@@shopPicker/clear_shop_search_term',
  DO_GET_LIST_OF_SHOPS_GT: '@@shopPicker/get_list_of_shops_gt',
  DO_SET_SHOP_SELECTION_MODE: '@@shopPicker/set_shop_selection_mode',
  DO_FORCE_SHOW_COSTS_SHOP_PICKER_POPUP: '@@shopPicker/force_show_costs_shop_picker_popup',
  DO_RESET_FORCE_SHOW_COSTS_SHOP_PICKER_POPUP: '@@shopPicker/reset_force_show_costs_shop_picker_popup',
  DO_CLEAR_SHOP_LOCAL_SELECTION: '@@shopPicker/clear_shop_local_selection',
  DO_SET_SHOP_LOCAL_SELECTION: '@@shopPicker/set_shop_local_selection',
  DO_SET_COSTS_SHOP_LOCAL_SELECTION: '@@shopPicker/set_costs_shop_local_selection',
  DO_CLEAR_COSTS_SHOP_LOCAL_SELECTION: '@@shopPicker/clear_costs_shop_local_selection',
  DO_SET_LOCAL_SELECTED_TAB: '@@shopPicker/set_local_selected_tab',
  DO_RESET_SHOP_SELECTION_CHANGED: '@@shopPicker/reset_shop_selection_changed',
  DO_GET_DISPUTE_SHOP_LIST: '@@shopPicker/get_dispute_shop_list',
  DO_SET_DISPUTE_SHOP_SELECTION: '@@shopPicker/set_dispute_shop_selection',
  DO_FORCE_SHOW_DISPUTE_SHOP_PICKER_POPUP: '@@shopPicker/force_show_dispute_shop_picker_popup',
  DO_RESET_FORCE_SHOW_DISPUTE_SHOP_PICKER_POPUP: '@@shopPicker/reset_force_show_dispute_shop_picker_popup',
  // @generator action:type
  ...createRequestTypes('@@shopPicker', 'GET_SHOP_LIST'),
  ...createRequestTypes('@@shopPicker', 'SET_SHOP_SELECTION'),
  ...createRequestTypes('@@shopPicker', 'GET_SHOP_LIST_GT'),
  ...createRequestTypes('@@shopPicker', 'GET_COSTS_SHOP_LIST'),
  ...createRequestTypes('@@shopPicker', 'SET_COSTS_SHOP_SELECTION'),
  ...createRequestTypes('@@shopPicker', 'GET_DISPUTE_SHOP_LIST'),
  ...createRequestTypes('@@shopPicker', 'SET_DISPUTE_SHOP_SELECTION')
  // @generator action:type:request

}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action request
* * Insert a description
* @name getShopList
* @return {object} - The action object
*/
export const getShopList = new MakeRequest('shopPicker', 'get_shop_list')

/** @action request
* * Insert a description
* @name getCostsShopList
* @return {object} - The action object
*/
export const getCostsShopList = new MakeRequest('shopPicker', 'get_costs_shop_list')

/** @action request
* * Insert a description
* @name setShopSelection
* @return {object} - The action object
*/
export const setShopSelection = new MakeRequest('shopPicker', 'set_shop_selection')

/** @action request
* * Insert a description
* @name setCostsShopSelection
* @return {object} - The action object
*/
export const setCostsShopSelection = new MakeRequest('shopPicker', 'set_costs_shop_selection')

/** @action request
* * Insert a description
* @name getShopListGt
* @return {object} - The action object
*/
export const getShopListGt = new MakeRequest('shopPicker', 'get_shop_list_gt')

/** @action
 * * Insert a description
 * @name doSetShopSelection
 * @return {object} - The payload object
 */
export const doSetShopSelection = (group, data, selectorGroups) => createAction(actionTypes.DO_SET_SHOP_SELECTION, { group, data, selectorGroups })

/** @action
 * * Insert a description
 * @name doClearShopSelection
 * @return {object} - The payload object
 */
export const doClearShopSelection = (group, data) => createAction(actionTypes.CLEAR_SHOP_SELECTION, { group, data })

/** @action
 * * Insert a description
 * @name getShopList
 * @return {object} - The payload object
 */
export const doGetShopList = (payload) => createAction(actionTypes.DO_GET_SHOP_LIST, { payload })

/** @action
 * * Insert a description
 * @name getCostsShopList
 * @return {object} - The payload object
 */
export const doGetCostsShopList = (payload) => createAction(actionTypes.DO_GET_COSTS_SHOP_LIST, { payload })

/** @action
 * * Insert a description
 * @name setCostsShopSelection
 * @return {object} - The payload object
 */
export const doSetCostsShopSelection = (payload) => createAction(actionTypes.DO_SET_COSTS_SHOP_SELECTION, { payload })

/** @action
 * * Clear costs shop selection
 * @name doClearCostsShopSelection
 * @return {object} - The payload object
 */
export const doClearCostsShopSelection = (group, data) => createAction(actionTypes.CLEAR_COSTS_SHOP_SELECTION, { group, data })

/** @action
 * * Insert a description
 * @name setShopSearchTerm
 * @return {object} - The payload object
 */
export const doSetShopSearchTerm = (payload) => createAction(actionTypes.DO_SET_SHOP_SEARCH_TERM, { payload })

/** @action
 * * Insert a description
 * @name ClearSearchTerm
 * @return {object} - The payload object
 */
export const clearSearchTerm = (payload) => createAction(actionTypes.DO_CLEAR_SHOP_SEARCH_TERM, { payload })

/** @action
 * * Insert a description
 * @name GetListOfShopsGt
 * @param {number} pageNumber - The page number to fetch
 * @param {number} pageSize - The page size
 * @return {object} - The payload object
 */
export const doGetListOfShopsGt = (pageNumber = 0, pageSize = 15) => createAction(actionTypes.DO_GET_LIST_OF_SHOPS_GT, { pageNumber, pageSize })

/** @action
 * * Insert a description
 * @name SetShopSelectionMode
 * @return {object} - The payload object
 */
export const doSetShopSelectionMode = (mode, page) => createAction(actionTypes.DO_SET_SHOP_SELECTION_MODE, { mode, page })

/** @action
 * * Force show the shop picker popup
 * @name ForceShowShopPickerPopup
 * @return {object} - The payload object
 */
export const doForceShowCostsShopPickerPopup = () => createAction(actionTypes.DO_FORCE_SHOW_COSTS_SHOP_PICKER_POPUP)

/** @action
 * * Reset the force show popup flag
 * @name ResetForceShowShopPickerPopup
 * @return {object} - The payload object
 */
export const doResetForceShowCostsShopPickerPopup = () => createAction(actionTypes.DO_RESET_FORCE_SHOW_COSTS_SHOP_PICKER_POPUP)

/** @action
 * * Insert a description
 * @name SetShopLocalSelection
 * @return {object} - The payload object
 */
export const doSetShopLocalSelection = (payload) => createAction(actionTypes.DO_SET_SHOP_LOCAL_SELECTION, { payload })

/** @action
 * * Set costs shop local selection (replace instead of merge)
 * @name SetCostsShopLocalSelection
 * @return {object} - The payload object
 */
export const doSetCostsShopLocalSelection = (payload) => createAction(actionTypes.DO_SET_COSTS_SHOP_LOCAL_SELECTION, { payload })

/** @action
 * * Insert a description
 * @name ClearShopLocalSelection
 * @return {object} - The payload object
 */
export const doClearShopLocalSelection = (payload) => createAction(actionTypes.DO_CLEAR_SHOP_LOCAL_SELECTION, { payload })

/** @action
 * * Clear costs shop local selection (specific group)
 * @name ClearCostsShopLocalSelection
 * @return {object} - The payload object
 */
export const doClearCostsShopLocalSelection = (payload) => createAction(actionTypes.DO_CLEAR_COSTS_SHOP_LOCAL_SELECTION, { payload })

/** @action
 * * Clear costs shop local selection (specific group)
 * @name SetLocalSelectedTab
 * @return {object} - The payload object
 */
export const doSetLocalSelectedTab = (payload) => createAction(actionTypes.DO_SET_LOCAL_SELECTED_TAB, { payload })

/** @action
 * * Reset shop selection changed flag
 * @name ResetShopSelectionChanged
 * @return {object} - The payload object
 */
export const doResetShopSelectionChanged = () => createAction(actionTypes.DO_RESET_SHOP_SELECTION_CHANGED)

/** @action request
 * * Get dispute shop list
 * @name getDisputeShopList
 * @return {object} - The action object
 */
export const getDisputeShopList = new MakeRequest('shopPicker', 'get_dispute_shop_list')

/** @action request
 * * Set dispute shop selection
 * @name setDisputeShopSelection
 * @return {object} - The action object
 */
export const setDisputeShopSelection = new MakeRequest('shopPicker', 'set_dispute_shop_selection')

/** @action
 * * Trigger loading the dispute shop list
 * @name doGetDisputeShopList
 * @return {object} - The payload object
 */
export const doGetDisputeShopList = (payload) => createAction(actionTypes.DO_GET_DISPUTE_SHOP_LIST, { payload })

/** @action
 * * Set dispute shop selection
 * @name doSetDisputeShopSelection
 * @return {object} - The payload object
 */
export const doSetDisputeShopSelection = (payload) => createAction(actionTypes.DO_SET_DISPUTE_SHOP_SELECTION, { payload })

/** @action
 * * Force show the dispute shop picker popup
 * @name doForceShowDisputeShopPickerPopup
 * @return {object} - The payload object
 */
export const doForceShowDisputeShopPickerPopup = () => createAction(actionTypes.DO_FORCE_SHOW_DISPUTE_SHOP_PICKER_POPUP)

/** @action
 * * Reset the force show dispute popup flag
 * @name doResetForceShowDisputeShopPickerPopup
 * @return {object} - The payload object
 */
export const doResetForceShowDisputeShopPickerPopup = () => createAction(actionTypes.DO_RESET_FORCE_SHOW_DISPUTE_SHOP_PICKER_POPUP)

// @generator action
